export const LIST_PAYMENT_APP = [
  {
    id: 1,
    name: 'Abra'
  },
  {
    id: 2,
    name: 'AdvCash'
  },
  {
    id: 3,
    name: 'Afriex'
  },
  {
    id: 4,
    name: 'Airline Tickets'
  },
  {
    id: 5,
    name: 'AirPay'
  },
  {
    id: 6,
    name: 'AirTM'
  },
  {
    id: 7,
    name: 'Alipay'
  },
  {
    id: 8,
    name: 'AppleCash'
  },
  {
    id: 9,
    name: 'ApplePay'
  },
  {
    id: 10,
    name: 'AstroPay Direct'
  },
  {
    id: 11,
    name: 'Azimo'
  },
  {
    id: 12,
    name: 'Banco Brubank'
  },
  {
    id: 13,
    name: 'BanescoPagoMóvil'
  },
  {
    id: 14,
    name: 'Barter from Flutterwave'
  },
  {
    id: 15,
    name: 'Bhim'
  },
  {
    id: 16,
    name: 'Bill payment'
  },
  {
    id: 17,
    name: 'Bitjem Gift Card'
  },
  {
    id: 18,
    name: 'BitLipa'
  },
  {
    id: 19,
    name: 'Bitsika'
  },
  {
    id: 20,
    name: 'Bitwallet'
  },
  {
    id: 21,
    name: 'Bizum'
  },
  {
    id: 22,
    name: 'Bkash E-Wallet '
  },
  {
    id: 23,
    name: 'BNB CashApp'
  },
  {
    id: 24,
    name: 'Bnext'
  },
  {
    id: 25,
    name: 'Bunq Transfer'
  },
  {
    id: 26,
    name: 'Capital One 360 P2P Payment'
  },
  {
    id: 27,
    name: 'Carbon'
  },
  {
    id: 28,
    name: 'Cash app'
  },
  {
    id: 29,
    name: 'CashApp Payment'
  },
  {
    id: 30,
    name: 'CashU'
  },
  {
    id: 31,
    name: 'Cellulant'
  },
  {
    id: 32,
    name: 'Chime instant transfers'
  },
  {
    id: 33,
    name: 'Chipper Cash'
  },
  {
    id: 34,
    name: 'CIB smart wallet'
  },
  {
    id: 35,
    name: 'Circle Pay'
  },
  {
    id: 36,
    name: 'Current Pay'
  },
  {
    id: 37,
    name: 'Dash App'
  },
  {
    id: 38,
    name: 'Digital eRupee'
  },
  {
    id: 39,
    name: 'Ding Connect'
  },
  {
    id: 40,
    name: 'ePay'
  },
  {
    id: 41,
    name: 'Esewa'
  },
  {
    id: 42,
    name: 'Etisalat cash'
  },
  {
    id: 43,
    name: 'eZcash'
  },
  {
    id: 44,
    name: 'Facebook Messenger Payment'
  },
  {
    id: 45,
    name: 'Flashpay Netspend'
  },
  {
    id: 46,
    name: 'FNB E-WALLET'
  },
  {
    id: 47,
    name: 'Freecharge'
  },
  {
    id: 48,
    name: 'Frimi'
  },
  {
    id: 49,
    name: 'Gobank Money Transfer'
  },
  {
    id: 50,
    name: 'GönderAL'
  },
  {
    id: 51,
    name: 'Google Pay'
  },
  {
    id: 52,
    name: 'iCard'
  },
  {
    id: 53,
    name: 'Ininal'
  },
  {
    id: 54,
    name: 'Interac e-Transfer'
  },
  {
    id: 55,
    name: 'iudu'
  },
  {
    id: 56,
    name: 'Jawwal Pay'
  },
  {
    id: 57,
    name: 'JioMoney'
  },
  {
    id: 58,
    name: 'KoronaPay'
  },
  {
    id: 59,
    name: 'Lemon'
  },
  {
    id: 60,
    name: 'Lemonade Finance'
  },
  {
    id: 61,
    name: 'LiqPay'
  },
  {
    id: 62,
    name: 'mCash Mobile Payment'
  },
  {
    id: 63,
    name: 'Mercado Pago'
  },
  {
    id: 64,
    name: 'MobiKwik Wallet'
  },
  {
    id: 65,
    name: 'MobilePay'
  },
  {
    id: 66,
    name: 'Mobile Recharge'
  },
  {
    id: 67,
    name: 'MODO'
  },
  {
    id: 68,
    name: 'Momo'
  },
  {
    id: 69,
    name: 'N26'
  },
  {
    id: 70,
    name: 'NaranjaX'
  },
  {
    id: 71,
    name: 'NayaPay'
  },
  {
    id: 72,
    name: 'NBE Phone cash'
  },
  {
    id: 73,
    name: 'Neteller'
  },
  {
    id: 74,
    name: 'OkPay'
  },
  {
    id: 75,
    name: 'Other Online Wallets'
  },
  {
    id: 76,
    name: 'Pago Fácil'
  },
  {
    id: 77,
    name: 'Papara'
  },
  {
    id: 78,
    name: 'Payeer'
  },
  {
    id: 79,
    name: 'Payoneer'
  },
  {
    id: 80,
    name: 'PayPal'
  },
  {
    id: 81,
    name: 'Paypower'
  },
  {
    id: 82,
    name: 'Paysend.com'
  },
  {
    id: 83,
    name: 'Paysera Money Transfer'
  },
  {
    id: 84,
    name: 'PaySon'
  },
  {
    id: 85,
    name: 'Paytm Online Wallet'
  },
  {
    id: 86,
    name: 'Perfect Money'
  },
  {
    id: 87,
    name: 'Personal Pay'
  },
  {
    id: 88,
    name: 'Pesalink'
  },
  {
    id: 89,
    name: 'PhonePe'
  },
  {
    id: 90,
    name: 'PIM'
  },
  {
    id: 91,
    name: 'PlusGirot'
  },
  {
    id: 92,
    name: 'Powwi'
  },
  {
    id: 93,
    name: 'Przelewy24'
  },
  {
    id: 94,
    name: 'Pyypl'
  },
  {
    id: 95,
    name: 'Qiwi'
  },
  {
    id: 96,
    name: 'QQ Pay'
  },
  {
    id: 97,
    name: 'Quickteller'
  },
  {
    id: 98,
    name: 'Rapid Transfer'
  },
  {
    id: 99,
    name: 'Rapipago'
  },
  {
    id: 100,
    name: 'Remitly'
  },
  {
    id: 101,
    name: 'Revolut'
  },
  {
    id: 102,
    name: 'Rocket Remit'
  },
  {
    id: 103,
    name: 'Sendwave Wallet'
  },
  {
    id: 104,
    name: 'Simple Bank App'
  },
  {
    id: 105,
    name: 'Skrill'
  },
  {
    id: 106,
    name: 'SoFi Money Instant Transfer'
  },
  {
    id: 107,
    name: 'Sofort'
  },
  {
    id: 108,
    name: 'Stripe'
  },
  {
    id: 109,
    name: 'Swish'
  },
  {
    id: 110,
    name: 'Tap'
  },
  {
    id: 111,
    name: 'Tarjeta PAGO24'
  },
  {
    id: 112,
    name: 'Tarjeta PREX'
  },
  {
    id: 113,
    name: 'Tarjeta UALA'
  },
  {
    id: 114,
    name: 'Tele2'
  },
  {
    id: 115,
    name: 'Tigo Money'
  },
  {
    id: 116,
    name: 'Tpaga'
  },
  {
    id: 117,
    name: 'TransferGo'
  },
  {
    id: 118,
    name: 'TrueMoney'
  },
  {
    id: 119,
    name: 'Upaisa'
  },
  {
    id: 120,
    name: 'Venmo'
  },
  {
    id: 121,
    name: 'VIABUY Card2Card Transfer'
  },
  {
    id: 122,
    name: 'Viettel Money'
  },
  {
    id: 123,
    name: 'Volet.com (Formerly Advcash)'
  },
  {
    id: 124,
    name: 'Wari'
  },
  {
    id: 125,
    name: 'Wave Mobile Wallet'
  },
  {
    id: 126,
    name: 'WebMoney'
  },
  {
    id: 127,
    name: 'WeChat Pay'
  },
  {
    id: 128,
    name: 'Wise (TransferWise)'
  },
  {
    id: 129,
    name: 'Xoom Money Transfer'
  },
  {
    id: 130,
    name: 'YONO'
  },
  {
    id: 131,
    name: 'Yoomee Mobile Money'
  },
  {
    id: 132,
    name: 'Yoomoney'
  },
  {
    id: 133,
    name: 'Zelle'
  },
  {
    id: 134,
    name: 'Zelle Pay'
  },
  {
    id: 135,
    name: 'Zinli'
  },
  {
    id: 136,
    name: 'ZaloPay'
  },
  {
    id: 137,
    name: 'TNG eWallet'
  }
];
